import MERiT from "../catalog/catalog-components/ico-me-ep.svg";
import { Object } from "core-js";
import PropTypes from "prop-types";
import React, { Component, Fragment, useRef } from "react";
import getUrlParams from "../../utils/getUrlParams";
import PackageList from "./catalog-components/PackageList";
import FamilyMenu from "./catalog-navigation/FamilyMenu";
import FamilyTitleTestbase from "./catalog-components/package-item-components/testbase-components/FamilyTitleTestbase";
import TNCTBanner from "./catalog-components/package-item-components/testbase-components/TNCTBanner";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import PrintedTestsWarning from "./catalog-components/package-item-components/testbase-components/PrintedTestsWarning";
import paperImage from "../../images/img-tst-new.png"

class Catalog extends Component {
  state = {
    familyPackages: [],
    selectedPackages: [],
    selectPaperYear: "all",
    selectPaperTerm: "all",
    noPackagesMatch: false,
    menuOpen: true,
    width: 0,
    familyMenuItems: [
      {
        familyID: 18,
        family: "Sociology",
        active: false,
        icon: <i className="fa fa-user-friends subject__list"></i>,
        tab: 1
      },
      {
        familyID: 9,
        family: "Science",
        active: false,
        icon: <i className="fa fa-flask subject__list"></i>,
        tab: 2
      },
      {
        familyID: 19,
        family: "Religious Studies",
        active: false,
        icon: <i className="fa fa-hamsa subject__list"></i>,
        tab: 3
      },
      {
        familyID: 8,
        family: "Psychology",
        active: false,
        icon: <i className="fa fa-brain subject__list"></i>,
        tab: 4
      },
      {
        familyID: 7,
        family: "Physical Education",
        active: false,
        icon: <i className="fa fa-futbol subject__list"></i>,
        tab: 5
      },
      {
        familyID: 6,
        family: "Mathematics",
        active: false,
        icon: <i className="fa fa-cube subject__list"></i>,
        tab: 6
      },
      { 
        familyID: 5, 
        family: "Languages", 
        active: false, 
        icon: <i className="fa fa-comments subject__list"></i>,
        tab: 7
      },
      {
        familyID: 3,
        family: "Geography",
        active: false,
        icon: <i className="fa fa-globe-africa subject__list"></i>,
        tab: 8
      },
      { 
        familyID: 2, 
        family: "English", 
        active: false, 
        icon: <i className="fa fa-book-open subject__list"></i>,
        tab: 9
      },
      {
        familyID: 13,
        family: "Economics and Business",
        active: false,
        icon: <i className="fa fa-coins subject__list"></i>,
        tab: 10
      },
      {
        familyID: 10,
        family: "Design and Technology",
        active: false,
        icon: <i className="fa fa-crop subject__list"></i>,
        tab: 11
      },
      {
        familyID: 4,
        family: "Computer Science",
        active: false,
        icon: <i className="fa fa-network-wired subject__list"></i>,
        tab: 12
      },
      {
        familyID: 9999,
        family: "MERiT",
        active: false,
        icon: <img className="merit-svg" src={MERiT} alt="MERiT Logo" />,
        tab: 13
      },
      { 
        familyID: 1000, 
        family: "All Subjects", 
        active: false, 
        icon: <i className="fa fa-sync-alt subject__list"></i>, 
        tab: 14
      }
    ]
  };
  componentDidMount() {
    // if there is not a param for FID (familyID) then default to 1000 (All Packages)
    const familyIDParam = Number(getUrlParams().FID) || 1000;
    const familyPackages = this.setFamilyPackages(this.props.packages);
    this.setState({ familyPackages });
    this.props.updateMainState();
    const packagesFound = this.props.packages.filter(item =>
      item.Name.includes("MERiT")
    );
    // if there are no MERiT packages remove the MERiT Menu Item
    const noMerit = () => {
      if (packagesFound.length === 0) {
        this.state.familyMenuItems.splice(11, 1);
        return this.state.familyMenuItems;
      } else {
        return this.state.familyMenuItems;
      }
    };
    const meritBeGone = noMerit();
    this.setState({ familyMenuItems: meritBeGone });
    this.selectFamily(familyIDParam);
    this.setActiveMenuItem(familyIDParam);
    this.updateWidth();
    window.addEventListener("resize", this.updateWidth);
  }
  
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }
  
    updateWidth = () => {
      this.setState({width: window.innerWidth});
    }


  /**
   * set the familyPackages in state from the packages this.props.
   * The reduce function looks for every variation of the familyID and
   * only takes unique familyIDs and makes a new object.
   * It does this by using memoization (using a lookup tabe / object in this case)
   *
   * The reduce function also takes the existing array and then creates a sub array
   * in the object called packages and this uses a filter to only get the packages that
   * have a family of the current item in the reduce function.
   */
  setFamilyPackages = packages =>
    packages.reduce((acc, item, index, array) => {
      // destructure the item object
      const { familyID, family, familyDescription, familyOffer } = item;

      // create the object for the family with the identifier set to the familyID
      acc[familyID] = {
        familyID,
        family,
        familyDescription,
        familyOffer,
        packages: array.filter(
          currentPackage => currentPackage.familyID === familyID
        )
      };
      return acc;
    }, {});

  selectFamily = familyId => {
    const { packages } = this.props;

    //This hides the free products when we do the promotions. probably better to use package ID instead of product ID
    //const noFreeSpecial = packages.filter(data => data.productID !== "PK_EP_266" && data.productID !== "PK_EP_269" && data.productID !== "PK_EP_270" && data.productID !== "PK_EP_271")
    const noFreeSpecial = packages.filter(data => data.productID !== "PK_EP_266");
    // 1000 represents all packages
    if (familyId === 1000) {
      // purpose is to set selected packages to equal all packages
      this.setState({
        //when not doing a free promotion change 'noFreeSpecial' to 'packages'
        selectedPackages: noFreeSpecial
      });
    } else {
      const getPackages = () => {
        if (familyId === 9999) {
          const packagesFound = noFreeSpecial.filter(item =>
            item.Name.includes("MERiT")
          );
          return packagesFound.length === 0 ? packages : packagesFound;
        } else {
          const packagesFound = noFreeSpecial.filter(
            item => item.familyID === familyId
          );
          // if there are no packages found in the array then default to 1000 (All Packages)
          return packagesFound.length === 0 ? packages : packagesFound;
        }
      };

      const selectedPackages = getPackages();
      //  only set the state if there are packages,
      // if not then it makes react unresponsive because of an infinate amount of calls to set state
      if (selectedPackages.length > 0) {
        this.setState({ selectedPackages });
      }
    }
  };

  setActiveMenuItem = familyID => {
    let menu = [...this.state.familyMenuItems];

    const familyMenuItems = menu.map(item => {
      if (item.familyID === familyID) {
        item.active = true;
      } else {
        item.active = false;
      }
      return item;
    });
    
    //  only set the state if there are items,
    // if not then it makes react unresponsive because of an infinate amount of calls to set state
    if (familyMenuItems.length > 0) {
      this.setState({ familyMenuItems });
    }
    this.props.handleCloseSubject()
  };

  getActiveMenuName = () => {
    const res = [...this.state.familyMenuItems].find(
      item => item.active === true
    );
    // return selected family, or return All Subjects by default.
    return res ? res.family : "All Subjects";
  };

  TbCatalogComponent = (
    { addToBasket, basket, removePackageFromBasket, site },
    { familyPackages }
  ) => {
  
    // Function to filter and split packages by YEAR and BUNDLE (hopefully) from the package name
    const getYearlyPackages = packages => {
      const yearPattern = /Year (\d+)/;
      const bundlePattern = /\bbundle\b/i;
      
      return packages.reduce((acc, packageItem) => {
        const yearMatch = packageItem.Name.match(yearPattern);
        const isBundle = packageItem.Name.match(bundlePattern);
    
        if (isBundle) {
          if (!acc['Bundles']) {
            acc['Bundles'] = [];
          }
          acc['Bundles'].push(packageItem);
        } else if (yearMatch) {
          const year = yearMatch[0];
          if (!acc[year]) {
            acc[year] = [];
          }
          acc[year].push(packageItem);
        } else {
          if (!acc['other']) {
            acc['other'] = [];
          }
          acc['other'].push(packageItem);
        }
    
        return acc;
      }, {});
    };

    // Function to filter and split packages by TERM from the package name
    const getTerms = packages => {
      const termPattern = (/\b(Spring|Summer|Autumn|Winter)\b/);
      return packages.reduce((acc, packages) => {
        const match = packages.Name.match(termPattern);
        if (match) {
          const term = match[1];
          if (!acc[term]) {
            acc[term] = [];
          }
          acc[term].push(packages);
        }
        return acc;
      }, {});
    }

    // Function to handle year dropdown change
    const handleYearChange = event => {
      this.setState({selectPaperYear:event.target.value});
    };

     // Function to handle year dropdown change
    const handleTermChange = event => {
      this.setState({selectPaperTerm:event.target.value});
    }

    const handleScroll = () => {
      const findPapers = document.getElementById("papers");
      findPapers.scrollIntoView({behavior: "smooth"})
    }

     // Process familyPackages
    return (
      <Fragment>
        {Object.keys(familyPackages).map(key => {
          const { family, familyDescription, packages, familyID } = familyPackages[key];
          if (familyID === 15 && this.props.paperDates) {
            // Split packages by year
            const yearlyPackages = getYearlyPackages(packages);
            const years = Object.keys(yearlyPackages);
            const termPackages = getTerms(packages);
            const terms = Object.keys(termPackages);
            //this is needed for the filter dropdowns
            const isAll = this.state.selectPaperYear === "all";
            const selectedYears = isAll ? years : [this.state.selectPaperYear];

            //using TextLookups table. Create an object with properties named after the contentid and content as the values. In PHP you'd just use an assoc array
            //this way we can refer to content using dates.<contentid> - see examples below
            const dates = {};
            this.props.paperDates.forEach(function(date, index) {
              dates[date.contentid] = date.content;
            });
  
            return (
              <Fragment key={familyID}>
                {/* <PrintedTestsWarning /> */}
                {familyID === 15 && dates ? 
                  <div>
                    <div className="paper-image-container">
                      <div>
                        <FamilyTitleTestbase family={family} familyID={familyID} />
                        <p style={{fontSize:18}}>{dates.subheading}</p>
                      </div>
                      <div>
                        <img className="paper-image" alt="paper-spread" src={paperImage}/>
                      </div>
                    </div>
                  <div className="paper-row">
                    <div className="paper-first-block">
                      <div className="paper-info left">
                        <div>
                          <i className="fas fa-info-circle"></i>
                        </div>
                        <div>
                          <h5>You will require a Complete Primary Package subscription to order Testbase Standardised Tests.</h5>
                        </div>
                      </div>
                      <div className="scroll-btn">
                        <button onClick={handleScroll} className="packages-link btn-success">Order printed tests below</button>
                      </div>
                    </div>
                    <div className="paper-info right">
                      <div>
                        <i className="fas fa-info-circle"></i>
                      </div>
                      <div>
                        <h5>Deadline for ordering below</h5>
                        <p>Orders submitted after this date will not be charged or fulfilled.</p>
                        <p>{dates.aut_order_heading} <strong>{dates.aut_order_date}</strong></p>
                        <p>{dates.spr_order_heading} <strong>{dates.spr_order_date}</strong></p>
                        <p>{dates.sum_order_heading} <strong>{dates.sum_order_date}</strong></p>
                      </div>
                    </div>
                    <div className="paper-info right">
                      <div>
                        <i className="fas fa-info-circle"></i>
                      </div>
                      <div>
                        <h5>Delivery</h5>
                        <p>All completed orders will be delivered to schools for the week commencing:</p>
                        <p>{dates.aut_delivery_heading} <strong>{dates.aut_delivery_date}</strong></p>
                        <p>{dates.spr_delivery_heading} <strong>{dates.spr_delivery_date}</strong></p>
                        <p>{dates.sum_delivery_heading} <strong>{dates.sum_delivery_date}</strong></p>
                      </div>
                    </div>
                  </div>
                </div>
                : 
                <p className="family__desc">{familyDescription}</p>}
                <Container id="papers" fluid style={{paddingLeft: 0, paddingRight:0}}>
                  <Row className="filter-selection">
                    <Col className="first-child" xs={12} sm={2}>
                    <p>Filter resources</p>
                    </Col>
                    <Col xs={12} sm={2}>
                      {/* Year Dropdown */}
                      <select value={this.state.selectPaperYear} onChange={handleYearChange} className="paper-year-select">
                        <option value="all">Year</option>
                        {years.map(year => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </Col>
                      {terms.length > 1 && (
                        <Col xs={12} sm={2}>
                          {/* Term Dropdown */}
                            <select value={this.state.selectPaperTerm} onChange={handleTermChange} className="paper-year-select">
                              <option value="all">Term</option>
                              {terms.map(term => (
                                <option key={term} value={term}>
                                  {term}
                                </option>
                              ))}
                            </select>
                        </Col>
                      )}
                    <Col xs={12} sm={2} className="filter-btn">
                      <Button onClick={()=>this.setState({selectPaperYear:"all"}, this.setState({selectPaperTerm:"all"}))} className="btn clear-filter">Clear filters</Button>
                    </Col>
                  </Row>
                </Container>
                <>
                  {selectedYears.map(year => {
                    const matchingTerms = terms.filter(term =>
                      yearlyPackages[year]?.some(packages => packages.Name.includes(term))
                    );
                    let count = 0
                    return (
                      <Container fluid key={year}>
                        <Row className="filter-year-header">
                          <Col style={{ paddingLeft: 0}}>
                            <h4>{year}</h4>
                          </Col>
                        </Row>
                        {(this.state.selectPaperTerm === "all" 
                          ? matchingTerms 
                          : [this.state.selectPaperTerm]
                        ).map(term => (
                          <Row key={term + count++} className="filter-term-row">
                            <Col style={{ paddingLeft: 0}}>
                              <h5>{term}</h5>
                            </Col>
                            <PackageList
                              packages={yearlyPackages[year]?.filter(packages =>
                                packages.Name.includes(term)
                              )}
                              addToBasket={addToBasket}
                              updateBasket={this.props.updateBasket}
                              basket={basket}
                              removePackageFromBasket={removePackageFromBasket}
                              site={site}
                              familyID={familyID}
                              width={this.state.width}
                            />
                          </Row>
                        ))}
                      </Container>
                    );
                  })}
                </>
              </Fragment>
            );
          } else {
            return (
              <Fragment key={familyID}>
                {/* <FamilyTitleTestbase family={family} familyID={familyID} /> */}
                <p className="family__desc">{familyDescription}</p>
                <PackageList
                  packages={packages}
                  addToBasket={addToBasket}
                  updateBasket={this.props.updateBasket}
                  basket={basket}
                  removePackageFromBasket={removePackageFromBasket}
                  site={site}
                  familyID={familyID}
                  width={this.state.width}
                />
                {/* ADD THIS WHEN TST ORDERING CLOSES */}
                {/* <PrintedTestsWarning /> */}
              </Fragment>
            );
          }
        })}
      </Fragment>
    );
  };

  EpCatalogComponent = (
    { addToBasket, basket, removePackageFromBasket, site },
    { selectedPackages, familyMenuItems }
  ) => (
    <Container fluid>
      <Row>
        <Col xs={12} md={3} className="d-none d-md-block">
          <FamilyMenu
            selectFamily={this.selectFamily}
            familyMenuItems={familyMenuItems}
            setActiveMenuItem={this.setActiveMenuItem}
          />

          <Offcanvas show={this.props.showSubject} onHide={this.props.handleCloseSubject} placement="start" id="offcanvasNavbar-expand-sm" className={this.props.theme}>
            <Offcanvas.Header className="offcanvas__header">
              <Row className="order-Offcanvas__row">
                <Col xs={9} className="order-Offcanvas__header">
                  <h2>Subjects</h2>
                </Col>
                <Col xs={3} className="order-Offcanvas__close" aria-label="close">
                  <Button onClick={this.props.handleCloseSubject} className="order-Offcanvas__button"><i className="fa fa-times order-Offcanvas__icon"></i>Close</Button>
                </Col>
              </Row>
            </Offcanvas.Header>
            <Offcanvas.Body className="fixed-families__mobile">
            <div
              tabIndex={0}
              role="button"
              onClick={this.props.toggleSubjectMenu}
              onKeyDown={this.props.toggleSubjectMenu}
            >
              <Nav>
                <Nav style={{ backgroundColor: "#412878" }}>
                </Nav>
              </Nav>
              <FamilyMenu
                selectFamily={this.selectFamily}
                familyMenuItems={familyMenuItems}
                setActiveMenuItem={this.setActiveMenuItem}
              />
            </div>
            </Offcanvas.Body>
          </Offcanvas>
        </Col>
        <Col xs={12} md={9}>
            <h2 className="family-header">{this.getActiveMenuName()}</h2>
            <PackageList
            packages={selectedPackages}
            addToBasket={addToBasket}
            basket={basket}
            removePackageFromBasket={removePackageFromBasket}
            site={site}
            />
        </Col>
      </Row>
    </Container>
  );

  render() {
    return (
      // padding on parent needed - MATERIALS horizontal scroll fix when spacing is set above 0
      <Row className="justify-content-center">
        {this.props.site.brand !== "TB" ? (
          this.EpCatalogComponent(this.props, this.state)
        ) : (
          <Col xs={12} sm={12} md={10} lg={10}>
            {this.TbCatalogComponent(this.props, this.state)}
            {/* <TNCTBanner /> */}
          </Col>
        )}
      </Row>
    );
  }
}

Catalog.propTypes = {
  removePackageFromBasket: PropTypes.func,
  addToBasket: PropTypes.func,
  basket: PropTypes.array,
  packages: PropTypes.array,
  site: PropTypes.object,
  updateMainState: PropTypes.func
};

export default Catalog;
